import { fromJS } from 'immutable'
import {
  SUBCONTRACT_COST_EXPORT_REQUEST,
  SUBCONTRACT_COST_EXPORT_SUCCESS,
  SUBCONTRACT_COST_EXPORT_FAILURE,
  SUBCONTRACT_COST_EXPORT_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case SUBCONTRACT_COST_EXPORT_REQUEST:
      return state
        .set('isFetching', true)
    case SUBCONTRACT_COST_EXPORT_SUCCESS:
      return state
        .set('isFetching', false)
        .set('url', fromJS(action.payload.url))
    case SUBCONTRACT_COST_EXPORT_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
    case SUBCONTRACT_COST_EXPORT_RESET:
      return state
        .delete('url')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/subcontract-cost/subcontract-cost-export-reducer.js